<ion-header>
  <ion-toolbar>
    <ion-title>Filters</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Jobs</ion-card-title>
    </ion-card-header>

    <ion-list>
        <ion-item>
          <ion-label>Show Workshop Jobs</ion-label>
          <ion-toggle  [(ngModel)]="workshopConfiguration.showWorkshopJobs"></ion-toggle>
        </ion-item>

        <ion-item>
          <ion-label>Show Customer Jobs</ion-label>
          <ion-toggle [(ngModel)]="workshopConfiguration.showCustomerJobs" ></ion-toggle>
        </ion-item>

        
      </ion-list>

  </ion-card>

  <ion-card >
    <ion-card-header>
      <ion-card-title>Order by Job Number</ion-card-title>
    </ion-card-header>

    <ion-list>
      <ion-radio-group value="{{workshopConfiguration.jobOrdering}}"  (ionChange)="handleValueChange($event)">
        <ion-item>
          <ion-label>Ascending</ion-label>
            <ion-radio value="ascending" >

            </ion-radio>
        </ion-item>
        
        <ion-item>
          <ion-label>Descending</ion-label>
            <ion-radio value="descending" >

            </ion-radio>
        </ion-item>
        

      </ion-radio-group>
    </ion-list>  
  </ion-card>

<ion-button (click)="applyFilter()"  expand="full" shape="round" >Apply Filter</ion-button>

</ion-content>

